import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box, Button, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import wireframes from "../../assets/grouppy_wireframes.png";
import GlassCard from "../GlassCard";
import DemoLayout from "./DemoLayout";

export default function GrouppyPage() {
  const isMobile = useMediaQuery("(max-width: 700px)");

  return (
    <DemoLayout title="Grouppy">
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Box sx={{ width: "100%", maxWidth: { xs: "100%", md: "66.67%" } }}>
          <GlassCard>
            <Typography
              variant={isMobile ? "h6" : "h5"}
              color="secondary"
              sx={{ fontFamily: "Roboto", fontWeight: 700, mb: 2.5 }}
            >
              Grouppy
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "rgba(255,255,255,0.85)",
                fontFamily: "RobotoLight",
                fontWeight: 300,
                lineHeight: 1.85,
                mb: 2,
              }}
            >
              An automated assistant for managing large groups. Grouppy keeps
              track of your shopping list, tasks, and shared financials — all in
              one place.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "rgba(255,255,255,0.85)",
                fontFamily: "RobotoLight",
                fontWeight: 300,
                lineHeight: 1.85,
                mb: 3,
              }}
            >
              Built as a native Android application using Android Studio, Java,
              and Firebase as the real-time backend. Grouppy V1.0 is fully
              functional. The UI was designed following universal design
              principles to ensure accessibility.
            </Typography>

            <Box sx={{ mt: 1, mb: 3 }}>
              <Typography
                variant="caption"
                sx={{
                  color: "rgba(255,255,255,0.85)",
                  fontFamily: "RobotoLight",
                  fontWeight: 300,
                  textTransform: "uppercase",
                  letterSpacing: "1.4px",
                }}
              >
                Android Studio · Java · Firebase
              </Typography>
            </Box>

            <Button
              variant="outlined"
              startIcon={<OpenInNewIcon />}
              onClick={() =>
                window.open(wireframes, "_blank", "noopener,noreferrer")
              }
              sx={{
                borderColor: "rgba(179,157,219,0.85)",
                color: "#b39ddb",
                fontFamily: "Roboto",
                fontWeight: 500,
                "&:hover": {
                  borderColor: "#b39ddb",
                  background: "rgba(179,157,219,0.85)",
                },
              }}
            >
              View Wireframes
            </Button>
          </GlassCard>
        </Box>
      </Box>
    </DemoLayout>
  );
}
